import axiosInstance from "@/config/axios";
import axios from "axios";

export const handleUploadFile = async (
	event: React.ChangeEvent<HTMLInputElement>,
) => {
	// setImageWarning(false);

	try {
		console.log(event);
		const files = event?.target?.files;
		if (!files || files.length === 0) {
			console.error("No file selected for upload.");
			return;
		}

		const file = files[0];
		console.log("file: ", file);

		// const maxSize = 3 * 1024 * 1024; // 3MB in bytes
		// if (file.size > maxSize) {
		// 	event.target.value = "";
		// 	console.error("File size exceeds the 3MB limit.");
		// 	return;
		// }

		// setImageLoading(true);
		// setImageLoadingPercent(0);
		const fileData = file;
		const fileType = file.type;
		console.log("fileData: ", fileData);

		const responseUrl = await axiosInstance.post("/presigned-url", {
			fileType: fileType,
		});

		console.log("responseURL: ", responseUrl?.data?.data);

		// await axiosInstance.put(responseUrl?.data?.data?.url, fileData, {
		// 	headers: {
		// 		"Content-Type": " file/*; image/*",
		// 		"Access-Control-Allow-Origin": "*",
		// 		"Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
		// 		"Access-Control-Allow-Headers":
		// 			"Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
		// 	},
		// });

		await axios({
			method: "put",
			url: responseUrl?.data?.data?.url,
			data: fileData,
			headers: {
				"Content-Type": " file/*; image/*",
				"Access-Control-Allow-Origin": "*",
				"Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
				"Access-Control-Allow-Headers":
					"Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
			},
		});

		console.log("File Name: ", responseUrl?.data?.data?.fileName);
		return responseUrl?.data?.data?.fileName;
	} catch (error) {
		console.log(error);
		throw error;
	}
};
